module.exports = __webpack_public_path__ + "img/68114d2.png";